import { render, staticRenderFns } from "./HomeIndexGoodBusiness.vue?vue&type=template&id=f5bc42dc&scoped=true&"
import script from "./HomeIndexGoodBusiness.vue?vue&type=script&lang=js&"
export * from "./HomeIndexGoodBusiness.vue?vue&type=script&lang=js&"
import style0 from "./HomeIndexGoodBusiness.vue?vue&type=style&index=0&id=f5bc42dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bc42dc",
  null
  
)

export default component.exports